export { SplitImageFeatureSection as AlternatingRowsSection } from "../expanded-section-pack"